import React from 'react';
import classnames from 'classnames';

import Icon from 'buyside/components/presentation/Icon/icon';
import TooltipWhite from 'buyside/components/presentation/Tooltips/TooltipWhite/tooltipWhite';

import { sanitizeText } from './ShareButtonUtils';
import TwitterIcon from 'buyside/svgs/social_media/twitter_icon_white.svg';

import styles from './shareButtonStyles';

const TwitterButton = ({ shareText, style = '', url, id = '' }) => {
  return (
    <div>
      <TooltipWhite
        overlay={<div className={styles.twitterToolTip}>Share on Twitter</div>}
        placement="top"
      >
        <a
          data-testid={`twitter-button-${id}`}
          target="_blank"
          href={`https://twitter.com/intent/tweet?text=${sanitizeText(shareText)}${
            url ? `&url=${sanitizeText(url)}` : null
          }`}
        >
          <Icon type={TwitterIcon} className={classnames(styles.shareButton, style)} />
        </a>
      </TooltipWhite>
    </div>
  );
};

export default TwitterButton;
